<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-title"><span>CONTENTS</span></p>
<p class="toc-entry"><span><a href="#/xhtml/endmatter07">Series Introduction</a></span></p>
<p class="toc-entry"><span><a href="#/xhtml/franmatter03">Foreword</a></span></p>
<p class="toc-entry"><span><a href="#/xhtml/franmatter02">Author’s Note</a></span></p>
<p class="toc-entry"><span><a href="#/xhtml/franmatter01">Introduction</a></span></p>
<p class="toc-entrya"><span><a href="#/xhtml/chapter001">1. Gung Ho!</a></span></p>
<p class="toc-entry"><span><a href="#/xhtml/chapter002">2. Japan and the Philippines: Innocents Abroad.</a></span></p>
<p class="toc-entry"><span><span href="#/xhtml/chapter003" title="Link target outside of Sample">3. Washington: Fun in the Files</span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/chapter004" title="Link target outside of Sample">4. A Company Man in China</span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/chapter005" title="Link target outside of Sample">5. Life at Langley</span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/chapter006" title="Link target outside of Sample">6. North Thailand: Saving the Hill Tribes</span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/chapter007" title="Link target outside of Sample">7. Headquarters: Duping Congress</span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/chapter008" title="Link target outside of Sample">8. In Search of Reds</span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/chapter009" title="Link target outside of Sample">9. Headquarters: Ghosts in the Halls</span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/chapter010" title="Link target outside of Sample">10. The CIA in Vietnam: Transforming Reality</span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/chapter011" title="Link target outside of Sample">11. Coming Home</span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/chapter012" title="Link target outside of Sample">12. Down and Out in Thailand</span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/chapter013" title="Link target outside of Sample">13. Light at the End of the Tunnel</span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/chapter014" title="Link target outside of Sample">14. Conclusion</span></span></p>
<p class="toc-entrya"><span><span href="#/xhtml/endmatter01" title="Link target outside of Sample">Appendix: This Book and the Secrecy Agreement</span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/endmatter02" title="Link target outside of Sample">Sources</span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/endmatter04" title="Link target outside of Sample">Glossary</span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/endmatter03" title="Link target outside of Sample">Index</span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/endmatter05" title="Link target outside of Sample">Acknowledgments</span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/endmatter06" title="Link target outside of Sample">About the Author</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?591cf82a